import { FC, Fragment } from "react"
import { Translate } from "../../../../../../../../constant/Translate"
import { ButtonGroup } from "../../../../../../../../_webui/layout/components/Button/Group"
import { SubAdminSettingButtonGroupProps } from "../../../../../models/subAdmin/setting"

const { TEXT_T072, TEXT_T454, TEXT_T455, TEXT_T463 } = Translate

export const ButtonGroupTablet: FC<SubAdminSettingButtonGroupProps> = (
  props,
) => {
  const {
    goBack,
    goToRolesSetting,
    goToSubAdmin,
    isDisabledBtnSave,
    isHiddenBtn,
  } = props

  return (
    <Fragment>
      <ButtonGroup
        buttonItems={[
          {
            htmlType: "submit",
            isDisabled: isDisabledBtnSave,
            isHidden: !isHiddenBtn,
            text: TEXT_T454,
            type: "primary",
          },
          {
            isHidden: !isHiddenBtn,
            onClick: goToSubAdmin,
            text: TEXT_T455,
            type: "default",
          },
        ]}
      />

      <ButtonGroup
        buttonItems={[
          {
            isHidden: !isHiddenBtn,
            onClick: goToRolesSetting,
            text: TEXT_T463,
            type: "default",
          },
          {
            isAbsolute: true,
            isHidden: !isHiddenBtn,
            isSmall: true,
            onClick: goBack,
            text: TEXT_T072,
            type: "ghost",
          },
        ]}
        isMargin={false}
      />
    </Fragment>
  )
}
